import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  Grow,
  Box,
  useTheme,
} from "@mui/material";

import BuildIcon from "@mui/icons-material/Build";
import CodeIcon from "@mui/icons-material/Code";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import TransformIcon from "@mui/icons-material/Transform";
import PeopleIcon from "@mui/icons-material/People";

import { useNavigate } from "react-router-dom";

function Services() {
  const navigate = useNavigate();
  const theme = useTheme();

  const DARK_NAVY = "#0A192F";
  const LIGHT_GRAY = "#B0BEC5";

  const services = [
    {
      title: "In‑House Product Development",
      description:
        "We build future‑ready digital products with scalable architecture, secure engineering, and founder‑level product thinking.",
      icon: <BuildIcon fontSize="large" color="success" />,
      link: "/investverse",
    },
    {
      title: "IT Services & Engineering",
      description:
        "End‑to‑end development services including mobile apps, web apps, cloud, DevOps, UI/UX, QA automation, and API integrations.",
      icon: <CodeIcon fontSize="large" color="success" />,
      link: "/services/it-services",
    },
    {
      title: "Technology Consulting",
      description:
        "Expert guidance on architecture, product strategy, security, scalability, and cost optimization.",
      icon: <LightbulbIcon fontSize="large" color="success" />,
      link: "/services/consulting",
    },
    {
      title: "Digital Transformation",
      description:
        "We modernize legacy systems, migrate businesses to the cloud, automate workflows, and build digital‑first organizations.",
      icon: <TransformIcon fontSize="large" color="success" />,
      link: "/services/transformation",
    },
    {
      title: "Hire Developers",
      description:
        "Deploy highly skilled IT professionals including Flutter, React, Node, Cloud, QA, and Full‑Stack engineers.",
      icon: <PeopleIcon fontSize="large" color="success" />,
      link: "/services/hire-developers",
    },
    {
  title: "Training & Workshops",
  description:
    "Industry‑ready training in Full‑Stack engineering, AI/ML fundamentals, SDET automation, Backend development skills.",
  icon: <PeopleIcon fontSize="large" color="success" />,
  link: "/services/training",
},
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 8, md: 12 },
        backgroundColor: DARK_NAVY,
        color: "white",
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="h4" align="center" gutterBottom sx={{ color: "white" }}>
          Our Services
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{ mb: 4, maxWidth: 700, mx: "auto", color: LIGHT_GRAY }}
        >
          Arocoiris Technology delivers enterprise‑grade digital solutions backed by extensive experience across India, USA, and global technology ecosystems.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {services.map((service, index) => (
            <Grow in={true} timeout={800 + index * 300} key={index}>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Card
                  sx={{
                    height: "100%",
                    minHeight: 260,
                    maxWidth: 360,
                    mx: "auto",
                    background: "rgba(15, 23, 42, 0.9)",
                    borderRadius: 3,
                    border: "1px solid rgba(148, 163, 184, 0.25)",
                    textAlign: "center",
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
                    },
                  }}
                >
                  {service.icon}

                  <CardContent>
                    <Typography variant="h6" sx={{ color: "white", mb: 1 }}>
                      {service.title}
                    </Typography>

                    <Typography variant="body2" sx={{ color: LIGHT_GRAY }}>
                      {service.description}
                    </Typography>
                  </CardContent>

                  <CardActions sx={{ justifyContent: "center" }}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="success"
                      onClick={() => navigate(service.link)}
                      sx={{ borderRadius: 2 }}
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grow>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Services;